import { render, staticRenderFns } from "./OverviewPerBranchInformation.vue?vue&type=template&id=0ebe7d38&"
import script from "./OverviewPerBranchInformation.vue?vue&type=script&lang=ts&"
export * from "./OverviewPerBranchInformation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports